import { render, staticRenderFns } from "./DailyReportV2.vue?vue&type=template&id=907895a6&scoped=true"
import script from "./DailyReportV2.vue?vue&type=script&lang=js"
export * from "./DailyReportV2.vue?vue&type=script&lang=js"
import style0 from "./DailyReportV2.vue?vue&type=style&index=0&id=907895a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907895a6",
  null
  
)

export default component.exports